import { render, staticRenderFns } from "./FileIdentity.vue?vue&type=template&id=0694bdde"
import script from "./FileIdentity.vue?vue&type=script&lang=js"
export * from "./FileIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports